import * as React from 'react';
import axios from 'axios';
import {ICashierPaymentsProps, ICashierPaymentsApi} from 'cashier-payments-widget/dist/src/cashier-payments.d';
import CashierPaymentsLazyWidget from '../CashierPaymentsLazyWidget/CashierPaymentsLazyWidget';

export default class CashierPaymentsWrapper extends React.Component<ICashierPaymentsProps, { manifest }> {
    private manifestPromise;
    private apiPromise;
    private apiRsolve;
    private api;
    //private manifestUrt = 'https://ecom.wix.com/_api/cashier-settings-server/payments-widget-manifest';
    private manifestUrt = '/_api/cashier-settings-server/payments-widget-manifest';

    public getApi(): Promise<ICashierPaymentsApi> {
        return this.apiPromise;
    }

    constructor(props: ICashierPaymentsProps) {
        super(props);
        this.state = {manifest: null};
        this.apiPromise = new Promise((resolve, reject) => {
            this.apiRsolve = resolve;
        });
    }

    componentWillMount() {
        this.manifestPromise = axios.get(this.manifestUrt);
    }

    componentDidMount() {
        this.manifestPromise
            .then((response) => {
                this.setState({manifest: response.data});
                this.props.configuration.cashierPCIUrl = response.data.cashierPCIUrl;
            })
            .catch((error) => {
                //  console.log("axios error - ", error);
            });
    }

    render() {
        const lazyWidgetProps = Object.assign(
            {manifest: this.state.manifest},
            {initApi: api => this.apiRsolve(api)},
            this.props);

        return this.state.manifest ?
            <CashierPaymentsLazyWidget {...lazyWidgetProps} /> : null;
    }
}



// WEBPACK FOOTER //
// ./CashierPaymentsWrapper/CashierPaymentsWrapper.tsx